module.exports = __webpack_public_path__ + "img/facebook.29f1d360.svg";